import React from "react"

export default function DiffusionAdCanvaCardItem({ item, onClick }) {
  return (
    <div className="m-3" onClick={() => onClick(item)}>
      <button type="button" className="btn btn-block btn-light p-0">
        <div className="info-box bg-transparent mb-0 p-0">
          <div className="info-box-content">
            <div className="d-flex justify-content-between">
              <span style={{ maxWidth: "60%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {item.type === "folder" && <i className="fas fa-folder"></i>}
                {item.type === "design" && <i className="fas fa-paint-brush"></i>}
                {item.type === "image" && <i className="far fa-image"></i>}{" "}
                {item[item.type].title || item[item.type].name || "Sans titre"}
              </span>
              {item.type !== "folder" && (
                <span>
                  <i className="far fa-play-circle"></i> <em>~ secondes</em>
                </span>
              )}
            </div>
          </div>
        </div>
      </button>
    </div>
  )
}
